export default "__VITE_ASSET__BOoOuDnC__"